import React from "react"
import styled from "styled-components"
import CollapsibleCardContainer from "./CollapsibleFormCard"
import { responsive } from "../../common/styledHelpers"
import {
  CategoryContainer,
  Heading,
  ToolTip,
  Option,
  ResponseText,
  OptionWrapper,
} from "./CardSubSection"
import { nDashPlaceholder } from "./userDetailsUtilities"
// 4851-todo: update responsive helper

const QuestionRow = styled.div`
  display: flex;
  align-items: center;
  ${responsive("margin", "0", "0 0 8px 0")};
`

const QuestionText = styled(Heading)`
  margin: 0 6px 0 0;
  padding: ${props => props.isEditing ? '4px 0' : '0'};

`

const HealthCardContainer = ({
  questions,
  onAnswer,
  isEditing,
  renderResponse,
  getExtensionParent,
}) =>
  questions.sort((a, b) => a.order - b.order).map((question, questionIndex) => (
    <CategoryContainer
      key={question.token}
      last={questionIndex === questions.length - 1}
    >
      {question.text && (
        <QuestionRow>
          <QuestionText isEditing={isEditing}>{question.text}</QuestionText>
          {question.tooltip && isEditing && <ToolTip message={question.tooltip} />}
        </QuestionRow>
      )}
      {isEditing ? (
        <React.Fragment>
          {question.options && (
            <Options
              selected={question.answer}
              inline={true}
              question={questionIndex}
              name={question.text}
              options={question.options}
              inputType={question.inputType}
              onClick={onAnswer}
            />
          )}
          {question.answer &&
            question.options[question.answer].extensions &&
            question.options[question.answer].extensions.map(
              (extension, extensionIndex) => (
                <Options
                  key={extension.token}
                  question={questionIndex}
                  optionParent={getExtensionParent(questionIndex, extension.token)}
                  extension={extensionIndex}
                  name={question.text}
                  selected={extension.answer}
                  options={extension.options}
                  inputType={extension.display_type}
                  onClick={onAnswer}
                  inline={false}
                />
              )
            )}
        </React.Fragment>
      ) : (
        <ResponseText>{renderResponse(question)}</ResponseText>
      )}
    </CategoryContainer>
  ))

const Options = ({
  name,
  question,
  extension,
  optionParent,
  inline,
  onClick,
  options,
  selected,
  inputType,
}) => (
  <OptionWrapper inline={inline}>
    {options &&
      Object.keys(options)
        .sort((a, b) => options[a].order - options[b].order)
        .map(k => (
          <Option
            key={options[k].token}
            label={options[k].text}
            value={options[k].token}
            name={name}
            type={inputType}
            labelledBy=""
            inline={inline}
            selected={
              selected === k ||
              (!!selected && selected.length > 0 && selected.includes(k))
            }
            onClick={onClick(k, question, optionParent, extension)}
          />
        ))}
  </OptionWrapper>
)

class HealthCard extends React.Component {
  state = {
    isEditing: false,
    loading: false,
    error: null,
    edited: false,
  }

  onAnswer = (token, question, option, extension) => () => {
    if (!this.state.edited) this.setState({ edited: true })
    this.props.setAnswer(
      this.props.category,
      token,
      question,
      option,
      extension
    )
  }

  save = () => {
    this.setState({ loading: true, error: null })
    return this.props
      .saveProfileAnswers(this.props.selected.id, [this.props.category])
      .then(() =>
        this.setState({
          isEditing: false,
          loading: false,
          edited: false,
        })
      )
      .catch(() =>
        this.setState({
          error: "Something went wrong. Please try again.",
          loading: false,
        })
      )
  }

  edit = () => {
    this.props.editPredispositions(this.props.category)
    this.setState({
      isEditing: true,
      error: null,
      edited: false,
    })
  }

  cancel = () => {
    this.props.cancelEditPredispositions(this.props.category)
    this.setState({
      isEditing: false,
      error: null,
    })
  }

  isDisabled = () => {
    const none = this.props.questions.every(q => !q.answer || q.answer.length === 0)
    const some = this.props.questions.every(
      q =>
        (q.answer && q.options[q.answer].extensions.every(e => e.answer && e.answer.length > 0)) ||
        (!q.answer || q.answer.length === 0)
    )

    return none ? true : !some
  }

  getExtensionParent = (questionIndex, extensionToken ) => {
    let question = this.props.questions[questionIndex]
    return Object.keys(question.options).find(k => question.options[k].extensions.find(e => e.token === extensionToken))
  }

  renderResponse = question => {
    if (question && question.answer) {
      const response = []
      const answer = Array.isArray(question.answer)
        ? question.answer
        : [question.answer]
      answer.forEach(a => {
        response.push(question.options[a].text)
        question.options[a].extensions.forEach(e => {
          if (e.answer) {
            e.answer = Array.isArray(e.answer) ? e.answer : [e.answer]
            e.answer.forEach(a => {
              response.push(e.options[a].text)
            })
          }
        })
      })

      return response.join(", ")
    }

    return nDashPlaceholder
  }

  render() {
    const { isEditing, loading, edited } = this.state
    const { questions } = this.props
    const disabled = loading || this.isDisabled()
    return (
      <CollapsibleCardContainer
        {...this.state}
        {...this.props}
        edit={this.edit}
        cancel={this.cancel}
        save={this.save}
        showCompletion={true}
        dirty={isEditing}
        disabled={!edited || disabled}
      >
        <HealthCardContainer
          onAnswer={this.onAnswer}
          questions={questions}
          isEditing={isEditing}
          getExtensionParent={this.getExtensionParent}
          renderResponse={this.renderResponse}
        />
      </CollapsibleCardContainer>
    )
  }
}

export { HealthCard as default }



// WEBPACK FOOTER //
// ./assets/account/components/HealthCard.js